import React from 'react';
import { Box } from '@mui/material';
import { AU, FUENTE } from '../../styles/tokensAU';

const PildoraAU = ({ children, sx, ...resto }) => (
  <Box
    component="span"
    sx={[
      {
        display: 'inline-block',
        px: 1.5,
        py: 0.5,
        borderRadius: '999px',
        bgcolor: AU.azulSuave,
        color: AU.azulHover,
        fontFamily: FUENTE,
        fontSize: 12,
        fontWeight: 700,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...resto}
  >
    {children}
  </Box>
);

export default PildoraAU;
